import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";

import {useTranslation} from "react-i18next";

const PagesSwitch = ({
                         path,
                         pages,
                         renderLinks,
                         containerClass = false,
                         pageHeader,
                         boxShadow,
                         navBarButton,
                         basicContainer,
                         extraRoutes,
                         type = 'main',
                         ...props
                     }) => {


    path = path !== '/' ? path + '/' : path;

    const {t} = useTranslation();

    return (
        <div id="horizontalbar_content"
             className={`${containerClass ? 'container' : null} ${basicContainer ? 'basic_container' : ''}`}>
            <Switch>
                {pages &&
                pages.map((p) => {
                    return <Route key={p.path} path={path + p.path}
                                  render={() => <p.component {...p} {...props} path={path + p.path} pages={pages}/>}/>;
                })}
                {extraRoutes}
                <Redirect to={path + pages[0].path}/>
            </Switch>
        </div>
    );
};

export default PagesSwitch;
